<template>
    <div class="table-responsive">
        <table class="table table-bordered table-responsive-md">
            <thead>
                <tr>
                    <th class="text-center">{{ $t('dataSpaces') }}
                        <router-link style="float: right" :to="{ name: 'dataspaceadd'}"><i class="fas fa-lg fa-plus"></i></router-link>
                    </th>
                </tr>
            </thead>
            <tbody v-if="listOfDataSpaces.length > 0">
                <tr>
                    <input style="border:none" class="form-control" :placeholder="$t('dataSpaceName')" v-model="filterInput" type="search">
                </tr>
                <tr v-for="(item, i) in listOfDataSpaces" :key="i">
                    <td>
                        <router-link :to="{ name: 'dataspacedetail', params: { id: item.id } }">
                            {{ item.name }}
                        </router-link>
                        <i style="float:right; padding-top:10px; cursor: pointer" @click="showDeleteDataSpaceModal(item)" class="fas fa-sm fa-trash"></i>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <input class="form-control" :placeholder="$t('filterByName')" v-model="filterInput" type="search">
                </tr>
                <tr>
                    {{ $t('noAssignedDataSpace') }}
                </tr>
            </tbody>
        </table>
        <DataSpaceDeleteModal v-if="isModalVisible" @reload="requestData"></DataSpaceDeleteModal>
    </div>
</template>

<script>
import DataSpaceApi from "../../../api/server/dataspace";
import DataSpaceDeleteModal from "./DataSpaceDeleteModal";

export default {
    name: "DataSpaceList",
    components: {
        DataSpaceDeleteModal
    },
    mounted() {
        this.requestData();
    },
    computed: {
        listOfDataSpaces(){
            if (!this.filterInput){
                return this.dataSpaceList.sort((a, b) => a.name.localeCompare(b.name));
            } else {
                const lowerCaseFilter = this.filterInput.toLowerCase();

                return this.dataSpaceList.sort((a, b) => a.name.localeCompare(b.name)).filter((dataSpace) => { 
                    if(dataSpace.name.toLowerCase().includes(lowerCaseFilter))
                    return dataSpace;
                });
            }
        }
    },
    methods: {
        async requestData() {
            this.dataSpaceList = await DataSpaceApi.dataSpaceList();
        },
        showDeleteDataSpaceModal(item) {
            this.dataSpaceToDeleteId = item.id
            this.dataSpaceToDeleteName = item.name
            this.isModalVisible = true
        }
    },
    data() {
        return {
            dataSpaceList: [],
            dataSpaceToDeleteName: "",
            dataSpaceToDeleteId: "",
            isModalVisible: false,
            filterInput: ""
        }
    }
};
</script>
